import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

/** Dual speech bubbles with tails — fills use currentColor / brand via CSS classes on the SVG. */
const ChatBubblesIllustration: FC = () => (
  <svg aria-hidden viewBox='0 0 120 100' className='h-[6.25rem] w-[7.5rem]'>
    <rect x='8' y='14' width='68' height='44' rx='14' className='fill-brand-100' />
    <path d='M24 58l-4 14 16-14z' className='fill-brand-100' />
    <rect x='46' y='40' width='66' height='40' rx='14' className='fill-brand-600' />
    <path d='M98 80l4 14-16-14z' className='fill-brand-600' />
    <circle cx='64' cy='60' r='3.5' fill='white' />
    <circle cx='79' cy='60' r='3.5' fill='white' />
    <circle cx='94' cy='60' r='3.5' fill='white' />
  </svg>
);

type Props = {
  className?: string;
};

export const InboxEmptyState: FC<Props> = ({ className }) => {
  const { t } = useTranslation('whatsappInbox');

  return (
    <div className={twMerge('flex flex-col items-center justify-center gap-[18px] bg-primary-background px-10 text-center', className)}>
      <ChatBubblesIllustration />
      <div className='max-w-[340px]'>
        <p className='mb-1.5 text-[17px] font-bold text-primary-900'>{t('selectConversationTitle')}</p>
        <p className='text-sm leading-relaxed text-primary-900/60'>{t('selectConversationSubtitle')}</p>
      </div>
    </div>
  );
};
